export default __webpack_public_path__ + "static/media/Tamarin Battle Shield.ebabc1b3.jpg";